
export default function Blog() {
    return (
        <>
        <h1>WIP :)</h1>
        </>
    )
}